import React from "react";
import { Link } from "react-router-dom";
import get from "lodash/get";
import { Row, Col, Layout, Alert, Spin, Select } from "antd";

import Footer from "../../components/Footer/Footer";
import classes from "./Documents.css";

// import PhysicianScript from "../../assets/documents/Physician-Script.pdf";
// import PatientInformationSheetText from "../../assets/documents/Patient-Information-Sheet-Text.pdf";
// import PatientInformationSheetVisual from "../../assets/documents/Patient-Information-Sheet-Visual.pdf";
// import PatientConsentForm from "../../assets/documents/Patient-Consent-Form.pdf";
// import SurrogateConsentForm from "../../assets/documents/Surrogate-Consent-Form.pdf";
// import LetterOfBereavement from "../../assets/documents/Letter-of-Bereavement.docx";
// import SAEForm from "../../assets/documents/AcT-SAE-Report.pdf";
// import TrialProtocol from "../../assets/documents/AcT-trial-protocol.pdf";

import { getPublicDocumentsRequest } from "../../api/requests";
import FileButton from "../../components/FileLink/FileButton";

const { Content } = Layout;

const ALL_SITES_FILTER = "ALL_SITES_FILTER";

export default class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      documents: [],
      requestResult: {},
      sitesFilter: ALL_SITES_FILTER,
    };
  }

  componentDidMount = async () => {
    this.setState({ isLoading: true });

    try {
      const response = await getPublicDocumentsRequest();
      this.setState({ isLoading: false, documents: get(response, "data") });
    } catch (e) {
      this.setState({
        isLoading: false,
        requestResult: {
          type: "error",
          message: get(e, "response.data.error", "Error"),
        },
      });
    }
  };

  render() {
    const { isLoading, documents, requestResult } = this.state;

    const sites = documents.reduce((result, item) => {
      if (item.site === null && result.includes(null)) {
        return result;
      }

      if (
        result.find((resultItem) => {
          return get(resultItem, "id") === get(item.site, "id");
        })
      ) {
        return result;
      }

      result.push(item.site);
      return result;
    }, []);

    const documentsFiltered = () => {
      if (this.state.sitesFilter === null) {
        return documents.filter((document) => document.site === null);
      }

      if (this.state.sitesFilter !== ALL_SITES_FILTER) {
        return documents.filter(
          (document) => get(document.site, "id") === this.state.sitesFilter
        );
      }

      return documents;
    };

    const listItems = documentsFiltered().map((document) =>
      get(document, "url", "").slice(-4).includes(".mp4") ? (
        <li key={document.name}>
          <video width="100%" height="320px" controls>
            <source src={document.url} type="video/mp4" />
          </video>
        </li>
      ) : (
        <li key={document.name}>
          <a
            href={document.url}
            target="_blank"
            style={{ color: "#FAFAFA" }}
            className="menu-item"
          >
            {document.name}
          </a>
        </li>
      )
    );

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 20, offset: 2 }}
                md={{ span: 16, offset: 4 }}
                style={{ paddingTop: "4rem" }}
              >
                <h1>
                  <span style={{ color: "#286DA8" }}>AcT</span>
                </h1>

                <Row type="flex" justify="center">
                  <Col
                    xs={24}
                    sm={18}
                    md={18}
                    lg={20}
                    xl={22}
                    className="frosted-card"
                  >
                    <h2>Trial Documents</h2>
                    <p>
                      This page contains links to the various Trial documents
                    </p>
                    <p>&nbsp;</p>
                    {sites.length > 0 && (
                      <Select
                        optionFilterProp="children"
                        className={classes.siteFilterSelect}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value) =>
                          this.setState({
                            sitesFilter: value,
                          })
                        }
                        placeholder="Site Filter"
                      >
                        <Select.Option value={ALL_SITES_FILTER}>
                          All Sites
                        </Select.Option>
                        {sites.map((site, index) => (
                          <Select.Option
                            key={index}
                            value={site ? site.id : null}
                          >
                            {site ? `${site.code} - ${site.name}` : "General"}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                    <p>&nbsp;</p>
                    {isLoading && <Spin tip="Loading..." />}
                    <ul>
                      {!isLoading && listItems}
                      {/* <li><a href={TrialProtocol} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>Trial Protocol</a></li>
                                        <li><a href={PhysicianScript} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>Physician Script</a></li>
                                        <li><a href={PatientInformationSheetText} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>Patient Information Sheet - Text Version</a></li>
                                        <li><a href={PatientInformationSheetVisual} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>Patient Information Sheet - Visual Version</a></li>
                                        <li><a href={PatientConsentForm} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>Patient Consent Form</a></li>
                                        <li><a href={SurrogateConsentForm} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>Surrogate Consent Form</a></li>
                                        <li><a href={LetterOfBereavement} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>Letter of Bereavement</a></li>
                                        <li><a href={SAEForm} target='_blank' style={{ color: '#FAFAFA' }} className='menu-item'>SAE Form</a></li> */}
                    </ul>
                    <p>&nbsp;</p>
                    {requestResult.type && (
                      <div>
                        <Alert
                          message={requestResult.message}
                          type={requestResult.type}
                          className={classes.submitResult}
                        />
                        <br />
                      </div>
                    )}
                    <ul>
                      <li>
                        <Link
                          to="/"
                          style={{ color: "#FAFAFA" }}
                          className="menu-item"
                        >
                          {" "}
                          Home{" "}
                        </Link>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Content>
          <Footer />
        </Layout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Documents/Documents.js